import { Controller } from "@hotwired/stimulus";
import * as DropIn from "braintree-web-drop-in";
//import { Toast } from "bootstrap5";
export default class extends Controller {
  connect() {
    // console.log("dropin", DropIn);
    var submitButton = $("#submit-button");
    var thisElement = this.element;
    this.element.reset();
    console.log("bt data", this.data);
    DropIn.create(
      {
        authorization: this.data.get("clientToken"),
        selector: "#dropin-container",
        paypal: {
          flow: "checkout",
          singleUse: true,
          intent: "sale",
          amount: this.data.get("total"),
          currency: "USD",
        },
        venmo: {
          allowNewBrowserTab: false,

          allowDesktopWebLogin: true,
          paymentMethodUsage: "single_use", ///multi_use
        },
        // applePay: {
        //   displayName: "Radio Airplay",
        //   paymentRequest: {
        //     total: {
        //       label: this.data.get("paymentLabel") || "Radio Airplay",
        //       amount: this.data.get("total"),
        //     },
        //     // We recommend collecting billing address information, at minimum
        //     // billing postal code, and passing that billing postal code with all
        //     // Apple Pay transactions as a best practice.
        //     requiredBillingContactFields: ["postalAddress"],
        //   },
        //},
        googlePay: {
          googlePayVersion: 2,
          merchantId: this.data.get("googlepayMerchantId"),
          transactionInfo: {
            totalPriceStatus: "FINAL",
            totalPrice: this.data.get("total"),
            currencyCode: "USD",
          },
          allowedPaymentMethods: [
            {
              type: "CARD",
              parameters: {
                // We recommend collecting and passing billing address information with all Google Pay transactions as a best practice.
                billingAddressRequired: true,
                billingAddressParameters: {
                  format: "FULL",
                },
              },
            },
          ],
        },
      },
      function (err, dropinInstance) {
        if (err) {
          // Handle any errors that might've occurred when creating Drop-in
          console.error(err);
          return;
        }

        submitButton.prop("disabled", false);

        $(thisElement).on("submit", (e) => {
          console.log("jquery submit event");
          e.preventDefault();
          if (
            $("input[name*=payment_method_nonce]").val() == "" ||
            $("input[name*=payment_method_type]") == ""
          ) {
            alert("Please enter your payment method");
          } else {
            //             Turbo.navigator.submitForm(thisElement);
            //   $("#di_payment_form")[0].requestSubmit();
          }
        });
        submitButton.on("click", (e) => {
          submitButton.prop("disabled", true);

          console.log("click submit");
          e.preventDefault(); //e.stopPropagation();
          // console.log("submitting");
          dropinInstance.requestPaymentMethod(function (err, payload) {
            if (err) {
              // Handle errors in requesting payment method
              console.error(err);
              submitButton.prop("disabled", false);

              alert(`Oops. There was a problem. ${err}`);
              return false;
            }

            // Send payload.nonce to your server
            // form.submit()
            $("input[name*=payment_method_nonce]").val(payload.nonce);
            $("input[name*=payment_method_type]").val(payload.type);
            // native event doesnt trigger jquery onsubmit event (again) since we are in submit handler now
            //$("#di_payment_form")[0].requestSubmit();
            Turbo.navigator.submitForm(thisElement);
          });
        });
      }
    );
  }
}

// var braintree_setup=function(){

//   $('#di_payment_container').show();
//   $('#di_payment_submit').hide();
//   $('#dropin-container').html('<span id="updating">Updating payment form&hellip;</span>');
//     braintree.setup("<%= @client_token %>", "dropin", {
//       dataCollector: {
//         paypal: true,
//           kount: {environment: "<%= Rails.env.production? ? 'production' : 'sandbox' %>"}
//         },
//       container: "dropin-container",
//       paypal: {
//         singleUse: true,
//         intent: "sale",
//         amount: <%= @airplay_promo_lead_airplay_song.categories.length * AirplayPromoPayment.price_lookup %>,
//         currency: 'USD'
//       },

//       onReady: function(braintreeInstance){
//         console.log('onready');
//         deviceData = braintreeInstance.deviceData;
//         $('input[name=device_data]').val(deviceData);

//         $('#di_payment_submit').show();
//         $('#updating').hide();

//       },
//       onPaymentMethodReceived: function(obj){
//         //obj.nonce
//         //obj.type
//         console.log(obj);
//         $('input[name=payment_method_nonce]').val(obj.nonce);
//         $('input[name=payment_method_type]').val(obj.type);
//         $('#di_payment_submit').hide();
//         $('#di_payment_form').submit();
//       }
//     });

//   }
